<h1 mat-dialog-title>{{ app ? 'Edit' : 'Register' }} Application</h1>
<button mat-dialog-close mat-icon-button test-id="close-dialog">
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <form class="form-full-width" [formGroup]="form">
    <mat-form-field>
      <mat-label>Type</mat-label>
      <mat-select formControlName="type" test-id="select-type">
        <mat-option value="viewer">Viewer</mat-option>
        <mat-option value="form">Form</mat-option>
      </mat-select>
      <mat-hint>The type determines which context the application can be used in.</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input autocomplete="off" formControlName="name" matInput test-id="name" />
      <mat-hint>The name appears in the context menu for viewing containers or files.</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>URL</mat-label>
      <input
        autocomplete="off"
        formControlName="url"
        matInput
        placeholder="https://storage.googleapis.com/my-bucket/my-app/index.html"
        test-id="url"
      />
      <mat-hint>Point to the HTML index file for the application.</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Description</mat-label>
      <textarea formControlName="description" matInput rows="1" test-id="description"></textarea>
      <mat-hint>Description of the application.</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Match Container or File Types</mat-label>
      <mat-chip-grid #typeList aria-label="Query field value" formControlName="types">
        @for (value of form.controls.types.value; track value; let chipIndex = $index) {
          <mat-chip-row (click)="selectTypeChip(value)" (removed)="removeType(chipIndex)">
            {{ value }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-row>
        }
        <input
          #typeInputElement
          formControlName="typeInput"
          test-id="search-types"
          [matAutocomplete]="autoComplete"
          [matChipInputAddOnBlur]="true"
          [matChipInputFor]="typeList"
          (click)="filterAutocomplete()"
          (keyup)="filterAutocomplete()"
        />
        <mat-autocomplete
          #autoComplete="matAutocomplete"
          panelWidth="auto"
          test-id="container-tags-display-autocomplete"
          (optionSelected)="selectTypeOption($event)"
        >
          @for (suggestion of suggestedTypes; track suggestion) {
            <mat-option [value]="suggestion">
              {{ suggestion }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-chip-grid>
      <mat-hint
        >Associate this application to one or more container or file types. Click a type to define more specific match
        rules.</mat-hint
      >
    </mat-form-field>
    <div class="conditional-field" [ngClass]="{ revealed: selectedType }">
      @if (selectedType) {
        <mat-form-field>
          <mat-label>Matcher for type: {{ selectedType }}</mat-label>
          <textarea
            attr.test-id="matcher-for-type-{{ selectedType }}"
            class="json-field"
            matInput
            [formControl]="$any(form.get('matchers')).get(selectedType)"
            (blur)="formatJson(form.get('matchers').get(selectedType))"
          ></textarea>
          <mat-hint>Define additional properties to match for this type.</mat-hint>
        </mat-form-field>
      }
    </div>
    <mat-form-field>
      <mat-label>Application options</mat-label>
      <textarea
        class="json-field"
        formControlName="options"
        matInput
        test-id="application-options"
        (blur)="formatJson(form.get('options'))"
      ></textarea>
      <mat-hint>These are static options that are passed to the application.</mat-hint>
    </mat-form-field>
  </form>
</div>
<div align="end" mat-dialog-actions>
  <button mat-button test-id="cancel" (click)="dialogRef.close()">Cancel</button>
  <button color="primary" mat-flat-button test-id="submit" [disabled]="form.invalid" (click)="submit()">
    {{ app ? 'Save' : 'Register' }}
  </button>
</div>
